import * as Yup from 'yup';
import { Form } from '@webinex/antik';

export const SIGN_UP_SCHEMA_BASE = {
  email: Yup.string().email().field().nullable().required(),
  firstName: Yup.string().field().nullable().required(),
  lastName: Yup.string().field().nullable().required(),
  password: Yup.string().password().nullable().required(),
  passwordConfirmation: Yup.string()
    .nullable()
    .oneOf([Yup.ref('password'), null], { key: 'signup.passwordConfirmationMatchError' })
    .required(),
};

const SCHEMA = Yup.object(SIGN_UP_SCHEMA_BASE);

export const SIGN_UP_INITIAL_VALUE: Yup.InferType<typeof SCHEMA> = {
  email: null!,
  firstName: null!,
  lastName: null!,
  password: null!,
  passwordConfirmation: null!,
};

export function SignUpInfoFieldSet() {
  return (
    <>
      <Form.Item name="email" required>
        <Form.Input type="email" />
      </Form.Item>
      <Form.Item name="firstName" required>
        <Form.Input />
      </Form.Item>
      <Form.Item name="lastName" required>
        <Form.Input />
      </Form.Item>
      <Form.Item name="password" required>
        <Form.Input type="password" />
      </Form.Item>
      <Form.Item name="passwordConfirmation" required>
        <Form.Input type="password" />
      </Form.Item>
    </>
  );
}
